/**
 * Date parsing and comparison helpers for sibling-order filtering.
 * @module siblingOrderFilter/dateUtils
 */

/**
 * Derives a `year-month` comparison key from a date-of-service string.
 *
 * @param dos - A date-of-service string parseable by the `Date` constructor
 * @returns A `"<year>-<month>"` key (month is 0-indexed), or `null` when the
 *   input is missing or cannot be parsed into a valid date
 */
export const toYearMonthKey = (dos?: string): string | null => {
  if (!dos) {
    return null;
  }
  const parsed = new Date(dos);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return `${parsed.getFullYear()}-${parsed.getMonth()}`;
};

/**
 * Parses a date-of-service string into its epoch time in milliseconds.
 *
 * @param dos - A date-of-service string parseable by the `Date` constructor
 * @returns The epoch time in milliseconds, or `null` when the input is missing
 *   or cannot be parsed into a valid date
 */
export const toTime = (dos?: string): number | null => {
  if (!dos) {
    return null;
  }
  const time = new Date(dos).getTime();
  return Number.isNaN(time) ? null : time;
};
